import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { TableComponent } from '../../../shared/components/custom-table/table.component';
import { CustomToastComponent } from '../../../shared/components/toast/custom-toast.component';
import { HttpService } from '../../../shared/services/http.service';

interface EventAttendance {
    id: string;
    eventName: string;
    eventDate: string;
    eventLocation: string;
    eventOrganiser: string;
    description: string;
}

interface APIResponse {
    status: boolean;
    message: string;
    data: {
        description: string;
        eventOrganiser: string;
        location: string;
        eventId: string;
        id: string;
        name: string;
        eventTypeId: string;
        eventName: string;
        eventDate: string;
    }[];
}

const ERROR_LOAD_EVENT_TYPES = 'Failed to load Event Types';

@Component({
    selector: 'app-event-attendance',
    standalone: true,
    imports: [
        CommonModule,
        TableComponent,
        MatDialogModule,
        ReactiveFormsModule,
        FormsModule
    ],
    providers: [DatePipe],
    templateUrl: './event-attendance.component.html',
    styleUrls: ['./event-attendance.component.scss'],
})
export class EventAttendanceComponent implements OnInit {
    @ViewChild(TableComponent) tableComponent!: TableComponent;

    loading = false;
    data: EventAttendance[] = [];
    columns: string[] = [
        'firstName', 'lastName', 'DOB', 'email(Personal)', 'schoolName',
        "UseNo."
    ];
    id: string | null = null;

    constructor(
        private dialog: MatDialog,
        private httpService: HttpService,
        private snackBar: MatSnackBar,
        private fb: FormBuilder,
        private cdr: ChangeDetectorRef,
        private router: Router,
        private route: ActivatedRoute,
        private datePipe: DatePipe
    ) { }

    ngOnInit(): void {
        this.id = this.route.snapshot.paramMap.get('id');
        if (this.id) {
            this.fetchAttendance(this.id);
        }
    }

    fetchAttendance(id: string): void {
        this.loading = true;
        this.httpService.get<APIResponse>(`events/${id}/event-attendance`)
            .pipe(take(1))
            .subscribe({
                next: (response) => {
                    this.data = response?.data?.map(item => ({
                        id: item.eventId,
                        eventName: item.eventName || '-',
                        eventDate: item.eventDate
                            ? this.datePipe.transform(item.eventDate, 'dd-MM-yyyy') || '-'
                            : '-',
                        eventLocation: item.location || '-',
                        eventOrganiser: item.eventOrganiser || '-',
                        description: item.description || '-',
                    })) || [];
                },
                error: (err) => {
                    console.error(ERROR_LOAD_EVENT_TYPES, err);
                    this.showErrorToast(ERROR_LOAD_EVENT_TYPES);
                    // this.loading = false;
                },
                complete: () => {
                    this.loading = false;
                }
            });
    }

    private showSuccessToast(message: string): void {
        this.snackBar.openFromComponent(CustomToastComponent, {
            data: { message },
            duration: 3000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: ['no-padding-snackbar', 'success-toast']
        });
    }

    private showErrorToast(message: string | null | undefined): void {
        if (!message) return;
        this.snackBar.openFromComponent(CustomToastComponent, {
            data: { message },
            duration: 3000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: ['no-padding-snackbar', 'error-toast']
        });
    }
}